<!-- <span class="author">Votre assistant adhésion</span> -->
<!-- screen :{{heightTest}} -->
<h3 mat-dialog-title>{{data.title}}</h3>
<mat-dialog-content class=".mat-body" [innerHTML]="data.content"></mat-dialog-content>
<div mat-dialog-actions>
  <button gs1Button mat-dialog-close>J'ai compris</button>
</div>
<div class="pointer" [ngClass]="{'above': !screenWidthEnough}"></div>
